import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isAuthenticated: JSON.parse(localStorage.getItem('authstatus')) || false,
    pendingEmail : localStorage.getItem('pending-email') || null,

    authToken : localStorage.getItem('auth-token') || ''
}

export const authSlice = createSlice({
    name: 'authentication',

    initialState,
    reducers: {
        setAuthStatus: (state, action) =>{
             
            if (action.payload === 'authenticated') {
                state.isAuthenticated = true;
                localStorage.setItem('authstatus', true);
            }else{
                state.isAuthenticated = false;
                localStorage.setItem('authstatus', false);
                localStorage.removeItem('user');
                localStorage.removeItem('fundings');
                localStorage.setItem('funding-balance', 0);
                localStorage.setItem('subscriptionBalance', 0);
                localStorage.removeItem('subscriptions');
                localStorage.removeItem('notifications');
                localStorage.removeItem('auth-token');
            } 
            
        } ,
        
        setToken: (state, action) =>{
             
                state.authToken = action.payload;
                localStorage.setItem('auth-token', state.authToken);            
        } ,
        setPendingEmail: (state, action) =>{
             
            state.pendingEmail = action.payload;
            localStorage.setItem('pending-email', state.pendingEmail);            
    }
    }
})

export const {setAuthStatus, setToken, setPendingEmail} = authSlice.actions;
export default authSlice.reducer;